import {} from '@/components'
import { RuntimeType, useOSStore, useWindowResize } from '@/stores'
import { createRootRoute, Outlet, type RouteComponent } from '@tanstack/react-router'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { ToastContainer } from 'react-toastify'

const Root: RouteComponent = () => {
  useWindowResize()

  useEffect(() => {
    if (useOSStore.getState().runtime === RuntimeType.TMA) {
      window.Telegram.WebApp.expand()
    }
  }, [])

  return (
    <>
      <Helmet defaultTitle="Cheese" titleTemplate="Cheese - %s" />
      <Outlet />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss={true}
        draggable={false}
        pauseOnHover={true}
        theme="colored"
      />
    </>
  )
}

export const Route = createRootRoute({
  component: Root
})
